<div class="header-bottom">
    <nav class="navbar navbar-expand-sm navbar-dark bg-light">
        <div class="container">

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="mynavbar" >
                <ul class="navbar-nav me-auto">
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-sitemap"></i>
                            Client Payment</a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" href="javascript:void(0)"  (click)="loadPaymentPage('client-payment')">Create Payment Page </a></li>
                        </ul>
                    </li> -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false"><i class="fa fa-shopping-cart"></i>
                            view Catalogue</a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" href="javascript:void(0)"
                                    (click)="loadCatalogueView('view-catalogue')">view Catalogue</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                  <!-- Welcome Message -->
        <div class="welcome-user ms-auto">
  Welcome{{ userDisplayName ? ', ' + userDisplayName : '' }}
</div>
            </div> 
        </div>
    </nav>
</div>